import { render, staticRenderFns } from "./Tele2Button.vue?vue&type=template&id=3f4d12ce&scoped=true&"
import script from "./Tele2Button.vue?vue&type=script&lang=js&"
export * from "./Tele2Button.vue?vue&type=script&lang=js&"
import style0 from "./Tele2Button.vue?vue&type=style&index=0&id=3f4d12ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4d12ce",
  null
  
)

export default component.exports